"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../core/dist");
exports.toolDef = {
    name: 'loom_update_doc',
    description: 'Update an existing document — replace its markdown body and/or set its requires_load. Frontmatter is otherwise preserved and version is incremented when content changes. Status changes go through loom_set_status (not this tool). Use this tool to update Loom docs — do not edit weave files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Document id to update' },
            content: { type: 'string', description: 'New markdown body (no frontmatter). Omit to leave body unchanged.' },
            requires_load: { type: 'array', items: { type: 'string' }, description: 'Replacement requires_load array. Omit to leave unchanged.' },
        },
        required: ['id'],
    },
};
async function handle(root, args) {
    const id = args['id'];
    const newContent = args['content'];
    const newRequiresLoad = Array.isArray(args['requires_load']) ? args['requires_load'] : undefined;
    if (!newContent && newRequiresLoad === undefined) {
        throw new Error('At least one of content or requires_load must be provided (status changes go through loom_set_status)');
    }
    const { id: resolvedId, filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
    const doc = await (0, dist_1.loadDoc)(filePath);
    const currentContent = doc.content ?? '';
    const content = newContent ?? currentContent;
    // For a frontmatter-native plan, steps live in frontmatter and the body table is a
    // generated view — a body edit must NOT silently re-derive steps. Only a legacy
    // (body-backed) plan still parses its steps from the body table.
    const isLegacyPlan = doc.type === 'plan' && doc._stepsFromFrontmatter !== true;
    // version + updated track SPEC revisions, which is what staleness reads. Bump them
    // only when the caller supplies new `content` (a content edit). A status-only or
    // requires_load-only update is a lifecycle change, not a spec change, and must NOT
    // bump either — else marking a parent done would cascade false staleness to its
    // children. (We can't reliably diff against the stored body — titled docs get an
    // injected H1 on save — so "content provided" is the signal.) See
    // loom/refs/staleness-reference.md.
    const contentChanged = newContent !== undefined;
    const updated = {
        ...doc,
        ...(newRequiresLoad !== undefined ? { requires_load: newRequiresLoad } : {}),
        ...(contentChanged ? { version: doc.version + 1, updated: (0, dist_2.today)() } : {}),
        content,
        ...(isLegacyPlan ? { steps: (0, dist_2.parseStepsTable)(content) } : {}),
    };
    await (0, dist_1.saveDoc)(updated, filePath);
    return { content: [{ type: 'text', text: JSON.stringify({ id: resolvedId, filePath }) }] };
}
